import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../../../components/shared/Sidebar";
import Topbar from "../../../components/shared/Topbar";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/doctor", end: true, icon: "📊" },
  { label: "Profile", path: "/doctor/profile", icon: "👤" },
  { label: "Chambers", path: "/doctor/chambers", icon: "🏥" },
  { label: "Schedule", path: "/doctor/schedule", icon: "📅" },
  { label: "Appointments", path: "/doctor/appointments", icon: "📋" },
  { label: "History", path: "/doctor/history", icon: "📂" },
];

const PAGE_TITLES = {
  "/doctor": "Dashboard",
  "/doctor/profile": "My Profile",
  "/doctor/chambers": "Chamber Management",
  "/doctor/schedule": "Schedule Management",
  "/doctor/appointments": "Appointments",
  "/doctor/history": "Appointment History",
};

export default function DoctorLayout() {
  const { pathname } = useLocation();
  const title =
    Object.entries(PAGE_TITLES).find(([key]) => pathname === key)?.[1] ||
    "Doctor Portal";

  return (
    <div className="flex min-h-screen bg-slate-50">
      <Sidebar logo="👨‍⚕️" title="Doctor Portal" navItems={NAV_ITEMS} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar title={title} />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
